import { Component } from '@angular/core';

@Component({
  selector: 'exa-cass-account-warnings-cell',
  template: `
    <button
        type="button"
        class="warnings"
        *ngIf="count > 0"
        [matTooltip]="count + (count === 1 ? ' bill warning' : ' bill warnings') + ', click to see the bills'"
        (click)="onClick()">
      <mat-icon class="warnings__icon">warning</mat-icon>
      <span>{{count}}</span>
    </button>
  `,
  styles: [`
    :host {
      display: flex;
      align-items: center;
      height: 100%;
    }

    .warnings {
      display: flex;
      align-items: center;
      padding: 2px 6px;
      border: none;
      border-radius: 4px;
      background: none;
      font: inherit;
      font-size: 13px;
      font-weight: 500;
      color: #ef6c00;
      cursor: pointer;
    }

    .warnings:hover {
      background-color: #fff3e0;
      text-decoration: underline;
    }

    .warnings__icon {
      width: 18px;
      height: 18px;
      margin-right: 4px;
      font-size: 18px;
    }
  `],
})
export class CassAccountWarningsCellComponent {
  params: any;
  count: number;

  agInit(params: any) {
    this.params = params;
    this.count = params.data ? params.data.conflicts_count || 0 : 0;
  }

  refresh(params: any): boolean {
    this.agInit(params);
    return true;
  }

  onClick() {
    this.params.context.componentParent.onWarningsClicked(this.params.data);
  }
}
